import React from "react";

const PlayerRepImg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="407.584"
        height="265.244"
        viewBox="0 0 407.584 265.244"
      >
        <g id="sponsor" transform="translate(-1347 -1466)">
          <g id="Group_12" data-name="Group 12">
            <g
              id="Group_3"
              data-name="Group 3"
              transform="translate(1034 -565)"
            >
              <line
                id="Line_4"
                data-name="Line 4"
                x2="193.654"
                y2="1.138"
                transform="translate(451.247 2206.86)"
                fill="none"
                stroke="#707070"
                stroke-width="1"
              />
              <g id="undraw_creative_team_r90h" transform="translate(313 2031)">
                <ellipse
                  id="Ellipse_55"
                  data-name="Ellipse 55"
                  cx="92.286"
                  cy="96.372"
                  rx="92.286"
                  ry="96.372"
                  transform="translate(217.563 43.253)"
                  fill="#f2f2f2"
                />
                <ellipse
                  id="Ellipse_56"
                  data-name="Ellipse 56"
                  cx="35.243"
                  cy="36.804"
                  rx="35.243"
                  ry="36.804"
                  transform="translate(14.826)"
                  fill="#ff6584"
                />
                <ellipse
                  id="Ellipse_57"
                  data-name="Ellipse 57"
                  cx="92.286"
                  cy="96.372"
                  rx="92.286"
                  ry="96.372"
                  transform="translate(25.726 10.244)"
                  fill="#f2f2f2"
                />
                <ellipse
                  id="Ellipse_58"
                  data-name="Ellipse 58"
                  cx="101.369"
                  cy="5.691"
                  rx="101.369"
                  ry="5.691"
                  transform="translate(7.559 191.606)"
                  fill="#3f3d56"
                />
                <ellipse
                  id="Ellipse_59"
                  data-name="Ellipse 59"
                  cx="75.936"
                  cy="3.925"
                  rx="75.936"
                  ry="3.925"
                  transform="translate(12.646 193.568)"
                  opacity="0.1"
                />
                <ellipse
                  id="Ellipse_60"
                  data-name="Ellipse 60"
                  cx="101.369"
                  cy="6.26"
                  rx="101.369"
                  ry="6.26"
                  transform="translate(204.847 230.686)"
                  fill="#3f3d56"
                />
                <ellipse
                  id="Ellipse_61"
                  data-name="Ellipse 61"
                  cx="75.936"
                  cy="4.318"
                  rx="75.936"
                  ry="4.318"
                  transform="translate(209.934 232.845)"
                  opacity="0.1"
                />
                <ellipse
                  id="Ellipse_62"
                  data-name="Ellipse 62"
                  cx="64.688"
                  cy="3.415"
                  rx="64.688"
                  ry="3.415"
                  transform="translate(80.971 218.924)"
                  fill="#3f3d56"
                />
                <ellipse
                  id="Ellipse_63"
                  data-name="Ellipse 63"
                  cx="31.211"
                  cy="1.648"
                  rx="31.211"
                  ry="1.648"
                  transform="translate(0 209.309)"
                  fill="#3f3d56"
                />
                <ellipse
                  id="Ellipse_64"
                  data-name="Ellipse 64"
                  cx="58.089"
                  cy="3.066"
                  rx="58.089"
                  ry="3.066"
                  transform="translate(288.137 259.111)"
                  fill="#3f3d56"
                />
                <rect
                  id="Rectangle_21"
                  data-name="Rectangle 21"
                  width="116.265"
                  height="72.089"
                  transform="translate(223.74 164.288)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_100"
                  data-name="Path 100"
                  d="M757.9,702.459Z"
                  transform="translate(-496.74 -474.05)"
                  fill="#3f3d56"
                  opacity="0.5"
                />
                <path
                  id="Path_101"
                  data-name="Path 101"
                  d="M1005.747,546.959s15.26,7.209,9.81,15.556-21.8,24.283-22.163,27.7a15.5,15.5,0,0,1-2.543,6.45s-7.267-7.968-6.54-8.727,7.993-7.968,8.357-9.865,11.263-16.694,11.263-16.694l-9.81-9.106Z"
                  transform="translate(-640.855 -377.549)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_102"
                  data-name="Path 102"
                  d="M1005.747,546.959s15.26,7.209,9.81,15.556-21.8,24.283-22.163,27.7a15.5,15.5,0,0,1-2.543,6.45s-7.267-7.968-6.54-8.727,7.993-7.968,8.357-9.865,11.263-16.694,11.263-16.694l-9.81-9.106Z"
                  transform="translate(-640.855 -377.549)"
                  opacity="0.1"
                />
                <path
                  id="Path_103"
                  data-name="Path 103"
                  d="M990.4,579.65s10.536,4.553,9.81,11.762,12.716,27.7,12.716,27.7,1.453,4.932,1.09,6.45,9.447,1.138,9.447,1.138v-3.415s-7.63-13.659-8.357-17.453-5.087-18.591-5.087-18.591-1.453-13.28-8.72-13.28A13.439,13.439,0,0,0,990.4,579.65Z"
                  transform="translate(-644.766 -394.305)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_104"
                  data-name="Path 104"
                  d="M980.2,498.459s21.8,18.591,21.073,20.109-11.263,7.209-13.08,7.588-14.671-27.7-14.671-27.7Z"
                  transform="translate(-634.02 -347.451)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_105"
                  data-name="Path 105"
                  d="M980.2,498.459s21.8,18.591,21.073,20.109-11.263,7.209-13.08,7.588-14.671-27.7-14.671-27.7Z"
                  transform="translate(-634.02 -347.451)"
                  opacity="0.1"
                />
                <path
                  id="Path_106"
                  data-name="Path 106"
                  d="M926.2,501.564s-2.18,10.244,3.633,14.418,15.623,20.489,16.713,20.489,16.713-8.727,15.987-10.244-8.72-14.8-8.72-14.8l-2.543-14.038S929.108,496.632,926.2,501.564Z"
                  transform="translate(-603.636 -346.762)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_107"
                  data-name="Path 107"
                  d="M991.9,420.459l3.27,22.006,5.813,15.556s8.72,9.485,3.633,10.244-7.993-10.244-7.993-10.244l-4.723-9.106Z"
                  transform="translate(-645.721 -299.045)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_108"
                  data-name="Path 108"
                  d="M991.9,420.459l3.27,22.006,5.813,15.556s8.72,9.485,3.633,10.244-7.993-10.244-7.993-10.244l-4.723-9.106Z"
                  transform="translate(-645.721 -299.045)"
                  opacity="0.1"
                />
                <path
                  id="Path_109"
                  data-name="Path 109"
                  d="M953.357,355.959s0,7.968-2.543,8.727,10.173,11,10.173,11-1.453-13.28,3.633-16.694Z"
                  transform="translate(-619.347 -259.018)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_110"
                  data-name="Path 110"
                  d="M953.357,355.959s0,7.968-2.543,8.727,10.173,11,10.173,11-1.453-13.28,3.633-16.694Z"
                  transform="translate(-619.347 -259.018)"
                  opacity="0.1"
                />
                <ellipse
                  id="Ellipse_66"
                  data-name="Ellipse 66"
                  cx="8.357"
                  cy="8.727"
                  rx="8.357"
                  ry="8.727"
                  transform="translate(331.467 85.938)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_111"
                  data-name="Path 111"
                  d="M939.984,382.427s-7.63-9.865-8.72-9.485-9.083,8.727-9.81,11.383-2.18,21.627-1.09,25.421,1.09,13.659.727,14.418-2.543,2.656-.363,2.656,9.81-5.691,14.9-4.553,11.99-.379,12.353-1.138-.363-20.489,0-22.006-.727-9.106-1.09-10.624-.363-7.588-4-9.106l-1.549-.16-.087,3.753Z"
                  transform="translate(-599.797 -269.55)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_112"
                  data-name="Path 112"
                  d="M931.4,449.959s.727,11.762,6.177,16.694,17.076,13.28,17.8,14.8,7.63,9.485,9.083,6.071a5.911,5.911,0,0,0,.291-3.364,8.38,8.38,0,0,0-3.6-5.468l-3.233-2.17L941.94,459.065l-.727-9.106Z"
                  transform="translate(-607.203 -317.353)"
                  fill="#ffb9b9"
                />
                <path
                  id="Path_113"
                  data-name="Path 113"
                  d="M978.321,651.19s-4.178-.949-5.631,1.707,1.453,9.865,1.453,9.865,8.357,18.212,9.81,15.936-1.09-10.624-1.09-10.624,3.633-8.347,2.18-8.727S978.321,655.743,978.321,651.19Z"
                  transform="translate(-633.23 -442.131)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_114"
                  data-name="Path 114"
                  d="M1052.813,703.994s-2.18-1.138-2.543,0-2.543,6.83,0,7.588,27.613,1.518,26.886,0-4.723-3.415-7.267-4.174-9.083-6.45-9.083-6.45S1057.173,705.891,1052.813,703.994Z"
                  transform="translate(-682.108 -473.119)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_115"
                  data-name="Path 115"
                  d="M962.056,316.659a2.327,2.327,0,0,0-.971-1.323,5.586,5.586,0,0,0-.2-1.746c-.534-1.648-1.8-1.554-2.992-2.283-.518-.316-.486-.6-.755-1.115a4.06,4.06,0,0,0-1.527-1.627,5.375,5.375,0,0,0-2.48-1.1c-1.9-.135-3.363,1.734-5.182,2.334-.8.264-1.664.275-2.47.525a2.319,2.319,0,0,0-1.731,1.716c-.055.4.042.813-.014,1.214-.112.8-.782,1.356-1.23,2.012a5.145,5.145,0,0,0-.085,5.077,7.186,7.186,0,0,0,.572.934,5.938,5.938,0,0,0,.6,2.135,10.424,10.424,0,0,0,3.583,3.737,9.2,9.2,0,0,1-.211-1.593,1.143,1.143,0,0,1,.065-.528c.159-.347.578-.439.9-.628a2.409,2.409,0,0,0,.941-2.058c.019-.8-.142-1.592-.062-2.383a1.327,1.327,0,0,1,.427-.958,1.425,1.425,0,0,1,.8-.2,8.747,8.747,0,0,0,3.973-.754,5.793,5.793,0,0,1,1.236-.653,2.6,2.6,0,0,1,2.644,1.379c.586.911.879,2,1.42,2.937a2.849,2.849,0,0,0,2.522,1.67.411.411,0,0,0,.312-.145.507.507,0,0,0,.057-.278l.058-4.175A6.576,6.576,0,0,0,962.056,316.659Z"
                  transform="translate(-613.815 -228.92)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_116"
                  data-name="Path 116"
                  d="M929.987,398.959s7.993,3.794,7.63,11.762,2.18,8.727-4,9.485-7.63,0-7.993.759-2.543-17.453-1.09-19.35S929.987,398.959,929.987,398.959Z"
                  transform="translate(-602.517 -285.703)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_133"
                  data-name="Path 133"
                  d="M994.484,740.69c0,7.724-4.4,10.42-9.82,10.42-.126,0-.251,0-.376,0-.251-.006-.5-.018-.747-.036-4.9-.362-8.7-3.2-8.7-10.38,0-7.432,9.094-16.811,9.779-17.507h0l.04-.041S994.484,732.967,994.484,740.69Z"
                  transform="translate(-634.86 -486.885)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_134"
                  data-name="Path 134"
                  d="M993.973,749.928l3.592-5.24-3.6,5.816-.009.6c-.251-.006-.5-.018-.747-.036l.387-7.726,0-.06.006-.01.037-.731-3.61-5.83,3.621,5.283.009.155.292-5.838-3.09-6.025,3.128,5,.3-12.1v0l-.051,9.544,3.077-3.784-3.089,4.606-.081,5.227,2.873-5.017-2.885,5.786-.045,2.906,4.169-6.983-4.186,8Z"
                  transform="translate(-644.526 -486.885)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_135"
                  data-name="Path 135"
                  d="M117.487,601.69c0,7.724-4.4,10.42-9.82,10.42-.126,0-.251,0-.376,0-.251-.006-.5-.018-.747-.036-4.9-.362-8.7-3.2-8.7-10.38,0-7.432,9.094-16.811,9.779-17.507h0l.04-.041S117.487,593.967,117.487,601.69Z"
                  transform="translate(-76.501 -400.624)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_136"
                  data-name="Path 136"
                  d="M116.974,610.928l3.592-5.24-3.6,5.816-.009.6c-.251-.006-.5-.018-.747-.036l.387-7.726,0-.06.006-.01.037-.731-3.61-5.83,3.621,5.283.009.155.292-5.838-3.09-6.025,3.128,5,.3-12.1v0l-.051,9.544,3.077-3.784-3.089,4.606-.081,5.227,2.873-5.017-2.885,5.786-.045,2.906,4.169-6.983-4.186,8Z"
                  transform="translate(-86.166 -400.624)"
                  fill="#3f3d56"
                />
              </g>
              <g
                id="undraw_deliveries_131a"
                transform="translate(538.307 2200.438)"
              >
                <path
                  id="Path_187"
                  data-name="Path 187"
                  d="M673.793,255.831a4.588,4.588,0,0,0-4.453-3.067,1.34,1.34,0,0,1-.824-.105,1.137,1.137,0,0,1-.34-.42,16.71,16.71,0,0,1-1.38-3.259c-.15-.5-.358-1.092-.866-1.221a1.163,1.163,0,0,0-1.1.48,10.508,10.508,0,0,1-.788.987c-1.2,1.062-3.307.093-4.567,1.068-.207.159-.379.363-.6.51a2.739,2.739,0,0,1-.694.3,66.647,66.647,0,0,0-7.18,2.8c.842,5.053,1.7,10.2,3.674,14.929.938,2.251,2,4.456,2.751,6.776,1.666,5.14,1.738,10.641,1.759,16.045,0,3.7,0,7.472-1.2,10.971a10.606,10.606,0,0,0-.676,2.4,2.494,2.494,0,0,0,.848,2.245,2.863,2.863,0,0,0,1.308.459,17.027,17.027,0,0,0,6.215-.72,167.56,167.56,0,0,1,16.65-2.7l9.35-1.2a5.475,5.475,0,0,0,1.936-.5c1.711-.933,1.873-3.5.809-5.134-.508-.783-1.227-1.425-1.657-2.254a2.09,2.09,0,0,1,.273-2.566c1.5-1.17,1.052-3.34,1.124-5.236q.3-7.958-.081-15.9a31.066,31.066,0,0,1-.054-3.3,29.071,29.071,0,0,1,1.031-5.509l2.841-11.163a5.832,5.832,0,0,0-3.509-2.251c-1.344-.336-2.748-.435-4.074-.846-2.706-.84-5.135-2.971-7.97-2.773a1.46,1.46,0,0,0-.619.15c-.637.363-.538,1.281-.577,2.014a5.571,5.571,0,0,1-2.6,3.928,47.013,47.013,0,0,0-4.038,2.725,1.8,1.8,0,0,0-.716,1.344Z"
                  transform="translate(-640.877 -245.657)"
                  fill="#8f89f8"
                />
                <path
                  id="Path_192"
                  data-name="Path 192"
                  d="M622.4,276.883a3.923,3.923,0,0,0-.992.921c-.346.525-.418,1.2-.716,1.74-.637,1.182-2.132,1.605-3.061,2.575a.957.957,0,0,0-.3.5,1.112,1.112,0,0,0,.25.726l4.492,7.046c1.5.132,2.928-.8,4.426-.678a4.473,4.473,0,0,0,1.666.072,4.846,4.846,0,0,0,1.067-.651c.9-.564,2.081-.63,2.829-1.371a3.772,3.772,0,0,0,.8-2.842,11.2,11.2,0,0,0-.268-2.611c-.661-2.7-2.733-4.783-4.032-7.178-.634-1.167-.977-1.849-2.315-1.047S623.664,275.958,622.4,276.883Z"
                  transform="translate(-617.329 -265.314)"
                  fill="#8f89f8"
                />
                <path
                  id="Path_193"
                  data-name="Path 193"
                  d="M797.664,266.787a10.538,10.538,0,0,1,2.261,1.974c.682.879,1.07,1.96,1.729,2.86a31.251,31.251,0,0,0,2.225,2.353,17.929,17.929,0,0,1,2.568,4.174,62.648,62.648,0,0,1-5.809,6.542,1.861,1.861,0,0,1-.884.576,1.418,1.418,0,0,1-1.245-.507c-.325-.336-.553-.756-.863-1.107a4.438,4.438,0,0,0-2.745-1.323,18.9,18.9,0,0,0-3.112-.045,1.2,1.2,0,0,1-.664-.111,1.1,1.1,0,0,1-.361-.414c-1.2-2.065-.827-4.657-.4-7.016l.983-5.4a12.118,12.118,0,0,1,.821-3c.373-.8,1.2-2.146,2.231-1.905S796.8,266.163,797.664,266.787Z"
                  transform="translate(-738.053 -258.78)"
                  fill="#8f89f8"
                />
              </g>
              <path
                id="Path_194"
                data-name="Path 194"
                d="M732.647,733.506a2.543,2.543,0,0,0-.61-.808,2.66,2.66,0,0,0-1.232-.436c-1.526-.273-3.335-.451-4.393.736-.988,1.112-.818,2.922-1.642,4.174a12.908,12.908,0,0,0-.843,1.138,4.438,4.438,0,0,0-.363,2.041c-.044,1.931-.087,3.87.044,5.8a8.345,8.345,0,0,0,1.333,4.58c1.555,2.034,4.36,2.326,6.845,2.455l2.016.11a3.835,3.835,0,0,0,1.649-.159,2.786,2.786,0,0,0,1.424-1.635c1.05-2.724-.61-5.657-1.635-8.389C734.06,739.963,734.271,736.477,732.647,733.506Z"
                transform="translate(-103.758 1509.129)"
                fill="#fff"
              />
              <path
                id="Path_195"
                data-name="Path 195"
                d="M780.288,709.188a4.75,4.75,0,0,1,.974,2.493,88.7,88.7,0,0,1,1.381,15.067,2.591,2.591,0,0,0,.258,1.366,1.684,1.684,0,0,0,.679.569c1.777.884,3.837-.349,5.319-1.7,2.743-2.508,5.065-5.877,5.221-9.683a23.26,23.26,0,0,1,.1-2.937,12.474,12.474,0,0,1,1.748-3.935,34.155,34.155,0,0,0,2.907-6.761c.269-.888.451-2-.218-2.622a2.3,2.3,0,0,0-.788-.429l-8.03-3.111c-.7-.269-2.427,4.371-2.7,4.879a3.711,3.711,0,0,1-2.689,2.231c-1.348.288-3.012-.129-4.3.588C777.971,706.41,779.057,707.894,780.288,709.188Z"
                transform="translate(-147.374 1533.618)"
                fill="#fff"
              />
              <g
                id="undraw_video_game_night_8h8m_1_"
                data-name="undraw_video_game_night_8h8m (1)"
                transform="translate(344.024 2067.044)"
              >
                <path
                  id="Path_204"
                  data-name="Path 204"
                  d="M204.205,602.546H.321v-.529H204.3Z"
                  transform="translate(-0.247 -455.991)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_209"
                  data-name="Path 209"
                  d="M282.243,175.6l-2.019,1.076a47.892,47.892,0,0,0-9.111-12.9,44.305,44.305,0,0,0-64.738,1.339c-17.5,19.113-16.925,49.61,1.275,67.985a45.8,45.8,0,0,0,11.759,8.619l-.987,2.139c-18.833-9.6-29.577-30.906-26.561-52.662s19.1-38.957,39.759-42.521S272.757,156,282.243,175.6Z"
                  transform="translate(-183.736 -148.004)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_210"
                  data-name="Path 210"
                  d="M274.148,434.567a17.57,17.57,0,0,0,.45,23.986,15.614,15.614,0,0,0,22.84-.472l2.781-3.038-23.29-23.513Z"
                  transform="translate(-243.934 -362.745)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_211"
                  data-name="Path 211"
                  d="M291.1,420.8a3.922,3.922,0,0,0,.1,5.347l21.361,21.566a3.481,3.481,0,0,0,5.092-.105,3.917,3.917,0,0,0-.1-5.347l-21.361-21.566a3.485,3.485,0,0,0-5.092.105Z"
                  transform="translate(-259.664 -353.74)"
                  fill="#fff"
                />
                <path
                  id="Path_212"
                  data-name="Path 212"
                  d="M494.249,252.715l2.781-3.038a17.57,17.57,0,0,0-.45-23.986,15.614,15.614,0,0,0-22.84.472l-2.781,3.038Z"
                  transform="translate(-398.745 -203.258)"
                  fill="#3f3d56"
                />
                <path
                  id="Path_213"
                  data-name="Path 213"
                  d="M460.247,244.855a3.922,3.922,0,0,0,.1,5.347l21.361,21.566a3.481,3.481,0,0,0,5.092-.105,3.917,3.917,0,0,0-.1-5.347l-21.361-21.566A3.485,3.485,0,0,0,460.247,244.855Z"
                  transform="translate(-389.736 -220.48)"
                  fill="#fff"
                />
                <path
                  id="Path_214"
                  data-name="Path 214"
                  d="M502.593,442.469v-1.752s7.281-4.3,13.2,0v1.593Z"
                  transform="translate(-423.071 -368.256)"
                  fill="#535461"
                />
                <path
                  id="Path_215"
                  data-name="Path 215"
                  d="M789.529,442.469v-1.752s7.281-4.3,13.2,0v1.593Z"
                  transform="translate(-643.72 -368.256)"
                  fill="#535461"
                />
                <path
                  id="Path_216"
                  data-name="Path 216"
                  d="M473.431,446.761H466.3s-1.82-2.23-7.888-2.071-7.281,2.071-7.281,2.071-5.992,4.221-7.357,9.478c0,0-7.357,23.177-7.508,41.337s6.522,20.708,10.011,21.186,9.708-.159,15.775-16.248l2.579-9.4s.455-5.575,5.916-2.071,10.315-1.911,10.315-1.911h20.478s6.826,4.46,13.045.956c0,0,2.427-3.345,4.7,7.965,0,0,6.977,23.257,17.747,20.867s9.556-21.823,9.556-21.823-1.441-29.708-7.357-40.222c0,0-5.688-10.912-9.48-11.39,0,0-8.191-1.593-11.376-.159l-1.82,1.593Z"
                  transform="translate(-372.066 -372.707)"
                  fill="#3f3d56"
                />
                <ellipse
                  id="Ellipse_72"
                  data-name="Ellipse 72"
                  cx="13.197"
                  cy="13.859"
                  rx="13.197"
                  ry="13.859"
                  transform="translate(71.634 75.806)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_73"
                  data-name="Ellipse 73"
                  cx="13.197"
                  cy="13.859"
                  rx="13.197"
                  ry="13.859"
                  transform="translate(140.5 75.806)"
                  fill="#535461"
                />
                <path
                  id="Path_217"
                  data-name="Path 217"
                  d="M519.295,486.161l-1.76,1.634a.787.787,0,0,1-1.078,0l-1.763-1.634a.875.875,0,0,1-.276-.637v-4.5a.837.837,0,0,1,.816-.855h3.527a.836.836,0,0,1,.816.854v4.5A.874.874,0,0,1,519.295,486.161Z"
                  transform="translate(-432.164 -399.586)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_218"
                  data-name="Path 218"
                  d="M519.295,524.564l-1.76-1.633a.787.787,0,0,0-1.078,0l-1.763,1.634a.875.875,0,0,0-.276.637V529.7a.836.836,0,0,0,.813.857h3.53a.836.836,0,0,0,.816-.854V525.2A.874.874,0,0,0,519.295,524.564Z"
                  transform="translate(-432.164 -431.811)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_219"
                  data-name="Path 219"
                  d="M493.873,511.567l1.556-1.851a.89.89,0,0,0,0-1.133l-1.556-1.851a.8.8,0,0,0-.607-.29h-4.278a.837.837,0,0,0-.815.857V511a.836.836,0,0,0,.813.857h4.281A.8.8,0,0,0,493.873,511.567Z"
                  transform="translate(-411.983 -419.484)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_220"
                  data-name="Path 220"
                  d="M532.462,511.562l-1.553-1.853a.888.888,0,0,1,0-1.133l1.556-1.851a.8.8,0,0,1,.607-.29h4.278a.836.836,0,0,1,.816.854V511a.836.836,0,0,1-.813.857h-4.279A.8.8,0,0,1,532.462,511.562Z"
                  transform="translate(-444.689 -419.479)"
                  fill="#e6e6e6"
                />
                <ellipse
                  id="Ellipse_74"
                  data-name="Ellipse 74"
                  cx="9.556"
                  cy="10.036"
                  rx="9.556"
                  ry="10.036"
                  transform="translate(93.174 94.762)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_75"
                  data-name="Ellipse 75"
                  cx="9.556"
                  cy="10.036"
                  rx="9.556"
                  ry="10.036"
                  transform="translate(126.241 94.762)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_76"
                  data-name="Ellipse 76"
                  cx="6.371"
                  cy="6.69"
                  rx="6.371"
                  ry="6.69"
                  transform="translate(96.359 98.107)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_221"
                  data-name="Path 221"
                  d="M588.411,570.172a4.625,4.625,0,1,1,4.4-4.62A4.513,4.513,0,0,1,588.411,570.172Zm0-8.921a4.306,4.306,0,1,0,4.1,4.3,4.2,4.2,0,0,0-4.1-4.3Z"
                  transform="translate(-485.681 -460.755)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_77"
                  data-name="Ellipse 77"
                  cx="6.371"
                  cy="6.69"
                  rx="6.371"
                  ry="6.69"
                  transform="translate(129.427 98.107)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_222"
                  data-name="Path 222"
                  d="M731.55,570.172a4.625,4.625,0,1,1,4.4-4.62A4.513,4.513,0,0,1,731.55,570.172Zm0-8.921a4.306,4.306,0,1,0,4.1,4.3,4.2,4.2,0,0,0-4.1-4.3Z"
                  transform="translate(-595.753 -460.755)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_78"
                  data-name="Ellipse 78"
                  cx="2.73"
                  cy="2.867"
                  rx="2.73"
                  ry="2.867"
                  transform="translate(116.837 103.045)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_79"
                  data-name="Ellipse 79"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(114.798 95.716)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_80"
                  data-name="Ellipse 80"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(117.031 95.716)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_81"
                  data-name="Ellipse 81"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(116.734 98.687)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_82"
                  data-name="Ellipse 82"
                  cx="0.607"
                  cy="0.637"
                  rx="0.607"
                  ry="0.637"
                  transform="translate(118.809 98.744)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_83"
                  data-name="Ellipse 83"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(120.902 98.687)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_84"
                  data-name="Ellipse 84"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(115.84 97.281)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_85"
                  data-name="Ellipse 85"
                  cx="0.607"
                  cy="0.637"
                  rx="0.607"
                  ry="0.637"
                  transform="translate(117.747 97.311)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_86"
                  data-name="Ellipse 86"
                  cx="0.607"
                  cy="0.637"
                  rx="0.607"
                  ry="0.637"
                  transform="translate(119.719 97.311)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_87"
                  data-name="Ellipse 87"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(121.795 97.281)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_88"
                  data-name="Ellipse 88"
                  cx="0.607"
                  cy="0.637"
                  rx="0.607"
                  ry="0.637"
                  transform="translate(118.809 95.718)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_89"
                  data-name="Ellipse 89"
                  cx="0.607"
                  cy="0.637"
                  rx="0.607"
                  ry="0.637"
                  transform="translate(120.932 95.718)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_90"
                  data-name="Ellipse 90"
                  cx="0.596"
                  cy="0.626"
                  rx="0.596"
                  ry="0.626"
                  transform="translate(122.689 95.716)"
                  fill="#535461"
                />
                <path
                  id="Path_223"
                  data-name="Path 223"
                  d="M574.251,458.847a1.087,1.087,0,0,0-1.058,1.111V463.3a1.087,1.087,0,0,0,1.058,1.111h.758a1.087,1.087,0,0,0,1.058-1.111v-3.345a1.087,1.087,0,0,0-1.058-1.111Z"
                  transform="translate(-477.361 -383.435)"
                  fill="#535461"
                />
                <path
                  id="Path_224"
                  data-name="Path 224"
                  d="M765.979,458.847a1.087,1.087,0,0,0-1.058,1.111V463.3a1.087,1.087,0,0,0,1.058,1.111h.759A1.087,1.087,0,0,0,767.8,463.3v-3.345a1.087,1.087,0,0,0-1.058-1.111Z"
                  transform="translate(-624.797 -383.436)"
                  fill="#535461"
                />
                <ellipse
                  id="Ellipse_91"
                  data-name="Ellipse 91"
                  cx="3.64"
                  cy="3.823"
                  rx="3.64"
                  ry="3.823"
                  transform="translate(150.208 77.399)"
                  fill="#e6e6e6"
                />
                <ellipse
                  id="Ellipse_92"
                  data-name="Ellipse 92"
                  cx="3.64"
                  cy="3.823"
                  rx="3.64"
                  ry="3.823"
                  transform="translate(142.472 85.523)"
                  fill="#e6e6e6"
                />
                <ellipse
                  id="Ellipse_93"
                  data-name="Ellipse 93"
                  cx="3.64"
                  cy="3.823"
                  rx="3.64"
                  ry="3.823"
                  transform="translate(158.247 85.045)"
                  fill="#e6e6e6"
                />
                <ellipse
                  id="Ellipse_94"
                  data-name="Ellipse 94"
                  cx="3.64"
                  cy="3.823"
                  rx="3.64"
                  ry="3.823"
                  transform="translate(150.814 93.488)"
                  fill="#e6e6e6"
                />
                <path
                  id="Path_225"
                  data-name="Path 225"
                  d="M597.272,449.654a3.152,3.152,0,0,0-3.068,3.222v14.257a3.152,3.152,0,0,0,3.068,3.222h31.171a3.152,3.152,0,0,0,3.068-3.222V452.876a3.152,3.152,0,0,0-3.068-3.222Z"
                  transform="translate(-493.518 -376.473)"
                  fill="#535461"
                />
                <path
                  id="Path_226"
                  data-name="Path 226"
                  d="M818.6,476.625h-4.937l2.383-4.29Zm-4.409-.319h3.861l-2-3.356Z"
                  transform="translate(-662.28 -393.651)"
                  fill="#535461"
                />
                <path
                  id="Path_227"
                  data-name="Path 227"
                  d="M786.073,512.228h-4.1V508.4h4.1Zm-3.792-.319h3.489v-3.186h-3.489Z"
                  transform="translate(-637.914 -420.971)"
                  fill="#535461"
                />
                <path
                  id="Path_228"
                  data-name="Path 228"
                  d="M851.555,509.245a2.392,2.392,0,1,1,2.275-2.389A2.334,2.334,0,0,1,851.555,509.245Zm0-4.46a2.073,2.073,0,1,0,1.972,2.071,2.023,2.023,0,0,0-1.972-2.071Z"
                  transform="translate(-689.668 -417.987)"
                  fill="#535461"
                />
                <path
                  id="Path_243"
                  data-name="Path 243"
                  d="M.168.012.479,0,.358,4.952.047,4.96Z"
                  transform="translate(152.477 95.741) rotate(-45)"
                  fill="#535461"
                />
                <path
                  id="Path_244"
                  data-name="Path 244"
                  d="M.012.168,4.956.047,4.948.359,0,.48Z"
                  transform="translate(152.481 98.796) rotate(-43.734)"
                  fill="#535461"
                />
                <path
                  id="Path_229"
                  data-name="Path 229"
                  d="M229.361,258.692c-8.282,2.4-17.351,4.2-20.6,1.4a19.777,19.777,0,0,0,2.892-9.187,5.365,5.365,0,0,1,6.176-5.266l2.149.317q.109.016.216.036a5.174,5.174,0,0,1,4.042,4.448A11.467,11.467,0,0,0,229.361,258.692Z"
                  transform="translate(-197.118 -221.91)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_230"
                  data-name="Path 230"
                  d="M294.909,361.074l3.22.7a1.7,1.7,0,0,1,1.158.919,1.856,1.856,0,0,1,.053,1.523h0a1.724,1.724,0,0,1-1.043.99,1.621,1.621,0,0,1-1.4-.181l-4.925-3.181-8.365-20.652,4.333-1.316Z"
                  transform="translate(-254.677 -293.326)"
                  fill="#a0616a"
                />
                <path
                  id="Path_231"
                  data-name="Path 231"
                  d="M60.611,377.684l-2.438.745-1.845-4L58.2,373.4Z"
                  transform="translate(-43.316 -282.836)"
                  fill="#a0616a"
                />
                <path
                  id="Path_232"
                  data-name="Path 232"
                  d="M59.55,442.3l-2.991-.832.468-5.4,2.574.166Z"
                  transform="translate(-43.493 -330.303)"
                  fill="#a0616a"
                />
                <path
                  id="Path_233"
                  data-name="Path 233"
                  d="M175.849,441.911,172.68,444.1,160.5,429.627a2.951,2.951,0,0,1-.649-2.327,2.86,2.86,0,0,1,1.291-2.01l15.179-9.525,2.325,7.014-7.9,7.789Z"
                  transform="translate(-159.48 -350.805)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_234"
                  data-name="Path 234"
                  d="M221.132,534.65l-.024.032a5.8,5.8,0,0,1-1.352,3.2,2.328,2.328,0,0,1-2.87,1.361h0a2.486,2.486,0,0,1-1.639-2.643l.592-5.557a4.02,4.02,0,0,0,3.051-2.841l1.38.987a3.832,3.832,0,0,1,1.548,2.534A3.955,3.955,0,0,1,221.132,534.65Z"
                  transform="translate(-202.095 -435.968)"
                  fill="#2f2e41"
                />
                <ellipse
                  id="Ellipse_95"
                  data-name="Ellipse 95"
                  cx="4.876"
                  cy="5.121"
                  rx="4.876"
                  ry="5.121"
                  transform="translate(15.663 25.35)"
                  fill="#a0616a"
                />
                <path
                  id="Path_235"
                  data-name="Path 235"
                  d="M237.969,291.391l-7.687,6.686-.6-2.752,1.342-2.148a16.36,16.36,0,0,0-.508-6.9l5.015,0A7.845,7.845,0,0,0,237.969,291.391Z"
                  transform="translate(-213.208 -252.734)"
                  fill="#a0616a"
                />
                <path
                  id="Path_236"
                  data-name="Path 236"
                  d="M230.5,322.745l-10.378,3.32-.807-3.876c-1.945-2.742-2.79-5.245-1.518-7.287l-.64-3.074a15.214,15.214,0,0,0,4.074-4.685l6.385-2.62,4.694.3L233.7,309.7Z"
                  transform="translate(-203.577 -266.55)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_237"
                  data-name="Path 237"
                  d="M286.207,314.591a10.336,10.336,0,0,0-6.2,1.994l.634-10.813h0a3.767,3.767,0,0,1,2.944,2.354Z"
                  transform="translate(-251.909 -267.497)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_238"
                  data-name="Path 238"
                  d="M218.117,428.214l-3.294-.851.485-29.392,4.423-5.087-.99-6.448-.641-7.224,10.8-2.813c3.652,6.963,5.859,13.294,2.637,17.249Z"
                  transform="translate(-201.78 -320.989)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_239"
                  data-name="Path 239"
                  d="M199.488,605.261l-.044.018a6.586,6.586,0,0,1-3.329,2.452,2.783,2.783,0,0,1-3.811-.473h0a3.142,3.142,0,0,1-.129-3.841l3.944-5.411a4.639,4.639,0,0,0,4.886-.952l.85,1.942a4.857,4.857,0,0,1,.1,3.668A4.539,4.539,0,0,1,199.488,605.261Z"
                  transform="translate(-183.908 -488.112)"
                  fill="#2f2e41"
                />
                <path
                  id="Path_240"
                  data-name="Path 240"
                  d="M161.913,385.155l-2.891,2.6a2.024,2.024,0,0,0-.637,1.776,1.962,1.962,0,0,0,1.085,1.517h0a1.834,1.834,0,0,0,2.425-.865l2.091-4.1,9.588-18.375L169.968,367Z"
                  transform="translate(-158.365 -313.871)"
                  fill="#a0616a"
                />
                <path
                  id="Path_241"
                  data-name="Path 241"
                  d="M210.1,343.712c-1.873-.594-3.627-.943-4.987-.482.285-3.706.873-7.017,2.784-8.6l2.716.335Z"
                  transform="translate(-194.311 -289.355)"
                  fill="#6c63ff"
                />
                <path
                  id="Path_242"
                  data-name="Path 242"
                  d="M236.119,254.213l-10.429-.674.128-2.19q5.461-3.867,10.429.674Z"
                  transform="translate(-210.137 -224.93)"
                  fill="#2f2e41"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default PlayerRepImg;

{
  /* <svg xmlns="http://www.w3.org/2000/svg" width="407.584" height="265.244" viewBox="0 0 407.584 265.244">
  <g id="sponsor" transform="translate(-1347 -1466)">
    <g id="Group_12" data-name="Group 12">
      <g id="Group_3" data-name="Group 3" transform="translate(1034 -565)">
        <line id="Line_4" data-name="Line 4" x2="193.654" y2="1.138" transform="translate(451.247 2206.86)" fill="none" stroke="#707070" stroke-width="1"/>
        <g id="undraw_creative_team_r90h" transform="translate(313 2031)">
          <ellipse id="Ellipse_55" data-name="Ellipse 55" cx="92.286" cy="96.372" rx="92.286" ry="96.372" transform="translate(217.563 43.253)" fill="#f2f2f2"/>
          <ellipse id="Ellipse_56" data-name="Ellipse 56" cx="35.243" cy="36.804" rx="35.243" ry="36.804" transform="translate(14.826)" fill="#ff6584"/>
          <ellipse id="Ellipse_57" data-name="Ellipse 57" cx="92.286" cy="96.372" rx="92.286" ry="96.372" transform="translate(25.726 10.244)" fill="#f2f2f2"/>
          <ellipse id="Ellipse_58" data-name="Ellipse 58" cx="101.369" cy="5.691" rx="101.369" ry="5.691" transform="translate(7.559 191.606)" fill="#3f3d56"/>
          <ellipse id="Ellipse_59" data-name="Ellipse 59" cx="75.936" cy="3.925" rx="75.936" ry="3.925" transform="translate(12.646 193.568)" opacity="0.1"/>
          <ellipse id="Ellipse_60" data-name="Ellipse 60" cx="101.369" cy="6.26" rx="101.369" ry="6.26" transform="translate(204.847 230.686)" fill="#3f3d56"/>
          <ellipse id="Ellipse_61" data-name="Ellipse 61" cx="75.936" cy="4.318" rx="75.936" ry="4.318" transform="translate(209.934 232.845)" opacity="0.1"/>
          <ellipse id="Ellipse_62" data-name="Ellipse 62" cx="64.688" cy="3.415" rx="64.688" ry="3.415" transform="translate(80.971 218.924)" fill="#3f3d56"/>
          <ellipse id="Ellipse_63" data-name="Ellipse 63" cx="31.211" cy="1.648" rx="31.211" ry="1.648" transform="translate(0 209.309)" fill="#3f3d56"/>
          <ellipse id="Ellipse_64" data-name="Ellipse 64" cx="58.089" cy="3.066" rx="58.089" ry="3.066" transform="translate(288.137 259.111)" fill="#3f3d56"/>
          <rect id="Rectangle_21" data-name="Rectangle 21" width="116.265" height="72.089" transform="translate(223.74 164.288)" fill="#3f3d56"/>
          <path id="Path_100" data-name="Path 100" d="M757.9,702.459Z" transform="translate(-496.74 -474.05)" fill="#3f3d56" opacity="0.5"/>
          <path id="Path_101" data-name="Path 101" d="M1005.747,546.959s15.26,7.209,9.81,15.556-21.8,24.283-22.163,27.7a15.5,15.5,0,0,1-2.543,6.45s-7.267-7.968-6.54-8.727,7.993-7.968,8.357-9.865,11.263-16.694,11.263-16.694l-9.81-9.106Z" transform="translate(-640.855 -377.549)" fill="#ffb9b9"/>
          <path id="Path_102" data-name="Path 102" d="M1005.747,546.959s15.26,7.209,9.81,15.556-21.8,24.283-22.163,27.7a15.5,15.5,0,0,1-2.543,6.45s-7.267-7.968-6.54-8.727,7.993-7.968,8.357-9.865,11.263-16.694,11.263-16.694l-9.81-9.106Z" transform="translate(-640.855 -377.549)" opacity="0.1"/>
          <path id="Path_103" data-name="Path 103" d="M990.4,579.65s10.536,4.553,9.81,11.762,12.716,27.7,12.716,27.7,1.453,4.932,1.09,6.45,9.447,1.138,9.447,1.138v-3.415s-7.63-13.659-8.357-17.453-5.087-18.591-5.087-18.591-1.453-13.28-8.72-13.28A13.439,13.439,0,0,0,990.4,579.65Z" transform="translate(-644.766 -394.305)" fill="#ffb9b9"/>
          <path id="Path_104" data-name="Path 104" d="M980.2,498.459s21.8,18.591,21.073,20.109-11.263,7.209-13.08,7.588-14.671-27.7-14.671-27.7Z" transform="translate(-634.02 -347.451)" fill="#2f2e41"/>
          <path id="Path_105" data-name="Path 105" d="M980.2,498.459s21.8,18.591,21.073,20.109-11.263,7.209-13.08,7.588-14.671-27.7-14.671-27.7Z" transform="translate(-634.02 -347.451)" opacity="0.1"/>
          <path id="Path_106" data-name="Path 106" d="M926.2,501.564s-2.18,10.244,3.633,14.418,15.623,20.489,16.713,20.489,16.713-8.727,15.987-10.244-8.72-14.8-8.72-14.8l-2.543-14.038S929.108,496.632,926.2,501.564Z" transform="translate(-603.636 -346.762)" fill="#2f2e41"/>
          <path id="Path_107" data-name="Path 107" d="M991.9,420.459l3.27,22.006,5.813,15.556s8.72,9.485,3.633,10.244-7.993-10.244-7.993-10.244l-4.723-9.106Z" transform="translate(-645.721 -299.045)" fill="#ffb9b9"/>
          <path id="Path_108" data-name="Path 108" d="M991.9,420.459l3.27,22.006,5.813,15.556s8.72,9.485,3.633,10.244-7.993-10.244-7.993-10.244l-4.723-9.106Z" transform="translate(-645.721 -299.045)" opacity="0.1"/>
          <path id="Path_109" data-name="Path 109" d="M953.357,355.959s0,7.968-2.543,8.727,10.173,11,10.173,11-1.453-13.28,3.633-16.694Z" transform="translate(-619.347 -259.018)" fill="#ffb9b9"/>
          <path id="Path_110" data-name="Path 110" d="M953.357,355.959s0,7.968-2.543,8.727,10.173,11,10.173,11-1.453-13.28,3.633-16.694Z" transform="translate(-619.347 -259.018)" opacity="0.1"/>
          <ellipse id="Ellipse_66" data-name="Ellipse 66" cx="8.357" cy="8.727" rx="8.357" ry="8.727" transform="translate(331.467 85.938)" fill="#ffb9b9"/>
          <path id="Path_111" data-name="Path 111" d="M939.984,382.427s-7.63-9.865-8.72-9.485-9.083,8.727-9.81,11.383-2.18,21.627-1.09,25.421,1.09,13.659.727,14.418-2.543,2.656-.363,2.656,9.81-5.691,14.9-4.553,11.99-.379,12.353-1.138-.363-20.489,0-22.006-.727-9.106-1.09-10.624-.363-7.588-4-9.106l-1.549-.16-.087,3.753Z" transform="translate(-599.797 -269.55)" fill="#6c63ff"/>
          <path id="Path_112" data-name="Path 112" d="M931.4,449.959s.727,11.762,6.177,16.694,17.076,13.28,17.8,14.8,7.63,9.485,9.083,6.071a5.911,5.911,0,0,0,.291-3.364,8.38,8.38,0,0,0-3.6-5.468l-3.233-2.17L941.94,459.065l-.727-9.106Z" transform="translate(-607.203 -317.353)" fill="#ffb9b9"/>
          <path id="Path_113" data-name="Path 113" d="M978.321,651.19s-4.178-.949-5.631,1.707,1.453,9.865,1.453,9.865,8.357,18.212,9.81,15.936-1.09-10.624-1.09-10.624,3.633-8.347,2.18-8.727S978.321,655.743,978.321,651.19Z" transform="translate(-633.23 -442.131)" fill="#2f2e41"/>
          <path id="Path_114" data-name="Path 114" d="M1052.813,703.994s-2.18-1.138-2.543,0-2.543,6.83,0,7.588,27.613,1.518,26.886,0-4.723-3.415-7.267-4.174-9.083-6.45-9.083-6.45S1057.173,705.891,1052.813,703.994Z" transform="translate(-682.108 -473.119)" fill="#2f2e41"/>
          <path id="Path_115" data-name="Path 115" d="M962.056,316.659a2.327,2.327,0,0,0-.971-1.323,5.586,5.586,0,0,0-.2-1.746c-.534-1.648-1.8-1.554-2.992-2.283-.518-.316-.486-.6-.755-1.115a4.06,4.06,0,0,0-1.527-1.627,5.375,5.375,0,0,0-2.48-1.1c-1.9-.135-3.363,1.734-5.182,2.334-.8.264-1.664.275-2.47.525a2.319,2.319,0,0,0-1.731,1.716c-.055.4.042.813-.014,1.214-.112.8-.782,1.356-1.23,2.012a5.145,5.145,0,0,0-.085,5.077,7.186,7.186,0,0,0,.572.934,5.938,5.938,0,0,0,.6,2.135,10.424,10.424,0,0,0,3.583,3.737,9.2,9.2,0,0,1-.211-1.593,1.143,1.143,0,0,1,.065-.528c.159-.347.578-.439.9-.628a2.409,2.409,0,0,0,.941-2.058c.019-.8-.142-1.592-.062-2.383a1.327,1.327,0,0,1,.427-.958,1.425,1.425,0,0,1,.8-.2,8.747,8.747,0,0,0,3.973-.754,5.793,5.793,0,0,1,1.236-.653,2.6,2.6,0,0,1,2.644,1.379c.586.911.879,2,1.42,2.937a2.849,2.849,0,0,0,2.522,1.67.411.411,0,0,0,.312-.145.507.507,0,0,0,.057-.278l.058-4.175A6.576,6.576,0,0,0,962.056,316.659Z" transform="translate(-613.815 -228.92)" fill="#2f2e41"/>
          <path id="Path_116" data-name="Path 116" d="M929.987,398.959s7.993,3.794,7.63,11.762,2.18,8.727-4,9.485-7.63,0-7.993.759-2.543-17.453-1.09-19.35S929.987,398.959,929.987,398.959Z" transform="translate(-602.517 -285.703)" fill="#6c63ff"/>
          <path id="Path_133" data-name="Path 133" d="M994.484,740.69c0,7.724-4.4,10.42-9.82,10.42-.126,0-.251,0-.376,0-.251-.006-.5-.018-.747-.036-4.9-.362-8.7-3.2-8.7-10.38,0-7.432,9.094-16.811,9.779-17.507h0l.04-.041S994.484,732.967,994.484,740.69Z" transform="translate(-634.86 -486.885)" fill="#6c63ff"/>
          <path id="Path_134" data-name="Path 134" d="M993.973,749.928l3.592-5.24-3.6,5.816-.009.6c-.251-.006-.5-.018-.747-.036l.387-7.726,0-.06.006-.01.037-.731-3.61-5.83,3.621,5.283.009.155.292-5.838-3.09-6.025,3.128,5,.3-12.1v0l-.051,9.544,3.077-3.784-3.089,4.606-.081,5.227,2.873-5.017-2.885,5.786-.045,2.906,4.169-6.983-4.186,8Z" transform="translate(-644.526 -486.885)" fill="#3f3d56"/>
          <path id="Path_135" data-name="Path 135" d="M117.487,601.69c0,7.724-4.4,10.42-9.82,10.42-.126,0-.251,0-.376,0-.251-.006-.5-.018-.747-.036-4.9-.362-8.7-3.2-8.7-10.38,0-7.432,9.094-16.811,9.779-17.507h0l.04-.041S117.487,593.967,117.487,601.69Z" transform="translate(-76.501 -400.624)" fill="#6c63ff"/>
          <path id="Path_136" data-name="Path 136" d="M116.974,610.928l3.592-5.24-3.6,5.816-.009.6c-.251-.006-.5-.018-.747-.036l.387-7.726,0-.06.006-.01.037-.731-3.61-5.83,3.621,5.283.009.155.292-5.838-3.09-6.025,3.128,5,.3-12.1v0l-.051,9.544,3.077-3.784-3.089,4.606-.081,5.227,2.873-5.017-2.885,5.786-.045,2.906,4.169-6.983-4.186,8Z" transform="translate(-86.166 -400.624)" fill="#3f3d56"/>
        </g>
        <g id="undraw_deliveries_131a" transform="translate(538.307 2200.438)">
          <path id="Path_187" data-name="Path 187" d="M673.793,255.831a4.588,4.588,0,0,0-4.453-3.067,1.34,1.34,0,0,1-.824-.105,1.137,1.137,0,0,1-.34-.42,16.71,16.71,0,0,1-1.38-3.259c-.15-.5-.358-1.092-.866-1.221a1.163,1.163,0,0,0-1.1.48,10.508,10.508,0,0,1-.788.987c-1.2,1.062-3.307.093-4.567,1.068-.207.159-.379.363-.6.51a2.739,2.739,0,0,1-.694.3,66.647,66.647,0,0,0-7.18,2.8c.842,5.053,1.7,10.2,3.674,14.929.938,2.251,2,4.456,2.751,6.776,1.666,5.14,1.738,10.641,1.759,16.045,0,3.7,0,7.472-1.2,10.971a10.606,10.606,0,0,0-.676,2.4,2.494,2.494,0,0,0,.848,2.245,2.863,2.863,0,0,0,1.308.459,17.027,17.027,0,0,0,6.215-.72,167.56,167.56,0,0,1,16.65-2.7l9.35-1.2a5.475,5.475,0,0,0,1.936-.5c1.711-.933,1.873-3.5.809-5.134-.508-.783-1.227-1.425-1.657-2.254a2.09,2.09,0,0,1,.273-2.566c1.5-1.17,1.052-3.34,1.124-5.236q.3-7.958-.081-15.9a31.066,31.066,0,0,1-.054-3.3,29.071,29.071,0,0,1,1.031-5.509l2.841-11.163a5.832,5.832,0,0,0-3.509-2.251c-1.344-.336-2.748-.435-4.074-.846-2.706-.84-5.135-2.971-7.97-2.773a1.46,1.46,0,0,0-.619.15c-.637.363-.538,1.281-.577,2.014a5.571,5.571,0,0,1-2.6,3.928,47.013,47.013,0,0,0-4.038,2.725,1.8,1.8,0,0,0-.716,1.344Z" transform="translate(-640.877 -245.657)" fill="#8f89f8"/>
          <path id="Path_192" data-name="Path 192" d="M622.4,276.883a3.923,3.923,0,0,0-.992.921c-.346.525-.418,1.2-.716,1.74-.637,1.182-2.132,1.605-3.061,2.575a.957.957,0,0,0-.3.5,1.112,1.112,0,0,0,.25.726l4.492,7.046c1.5.132,2.928-.8,4.426-.678a4.473,4.473,0,0,0,1.666.072,4.846,4.846,0,0,0,1.067-.651c.9-.564,2.081-.63,2.829-1.371a3.772,3.772,0,0,0,.8-2.842,11.2,11.2,0,0,0-.268-2.611c-.661-2.7-2.733-4.783-4.032-7.178-.634-1.167-.977-1.849-2.315-1.047S623.664,275.958,622.4,276.883Z" transform="translate(-617.329 -265.314)" fill="#8f89f8"/>
          <path id="Path_193" data-name="Path 193" d="M797.664,266.787a10.538,10.538,0,0,1,2.261,1.974c.682.879,1.07,1.96,1.729,2.86a31.251,31.251,0,0,0,2.225,2.353,17.929,17.929,0,0,1,2.568,4.174,62.648,62.648,0,0,1-5.809,6.542,1.861,1.861,0,0,1-.884.576,1.418,1.418,0,0,1-1.245-.507c-.325-.336-.553-.756-.863-1.107a4.438,4.438,0,0,0-2.745-1.323,18.9,18.9,0,0,0-3.112-.045,1.2,1.2,0,0,1-.664-.111,1.1,1.1,0,0,1-.361-.414c-1.2-2.065-.827-4.657-.4-7.016l.983-5.4a12.118,12.118,0,0,1,.821-3c.373-.8,1.2-2.146,2.231-1.905S796.8,266.163,797.664,266.787Z" transform="translate(-738.053 -258.78)" fill="#8f89f8"/>
        </g>
        <path id="Path_194" data-name="Path 194" d="M732.647,733.506a2.543,2.543,0,0,0-.61-.808,2.66,2.66,0,0,0-1.232-.436c-1.526-.273-3.335-.451-4.393.736-.988,1.112-.818,2.922-1.642,4.174a12.908,12.908,0,0,0-.843,1.138,4.438,4.438,0,0,0-.363,2.041c-.044,1.931-.087,3.87.044,5.8a8.345,8.345,0,0,0,1.333,4.58c1.555,2.034,4.36,2.326,6.845,2.455l2.016.11a3.835,3.835,0,0,0,1.649-.159,2.786,2.786,0,0,0,1.424-1.635c1.05-2.724-.61-5.657-1.635-8.389C734.06,739.963,734.271,736.477,732.647,733.506Z" transform="translate(-103.758 1509.129)" fill="#fff"/>
        <path id="Path_195" data-name="Path 195" d="M780.288,709.188a4.75,4.75,0,0,1,.974,2.493,88.7,88.7,0,0,1,1.381,15.067,2.591,2.591,0,0,0,.258,1.366,1.684,1.684,0,0,0,.679.569c1.777.884,3.837-.349,5.319-1.7,2.743-2.508,5.065-5.877,5.221-9.683a23.26,23.26,0,0,1,.1-2.937,12.474,12.474,0,0,1,1.748-3.935,34.155,34.155,0,0,0,2.907-6.761c.269-.888.451-2-.218-2.622a2.3,2.3,0,0,0-.788-.429l-8.03-3.111c-.7-.269-2.427,4.371-2.7,4.879a3.711,3.711,0,0,1-2.689,2.231c-1.348.288-3.012-.129-4.3.588C777.971,706.41,779.057,707.894,780.288,709.188Z" transform="translate(-147.374 1533.618)" fill="#fff"/>
        <g id="undraw_video_game_night_8h8m_1_" data-name="undraw_video_game_night_8h8m (1)" transform="translate(344.024 2067.044)">
          <path id="Path_204" data-name="Path 204" d="M204.205,602.546H.321v-.529H204.3Z" transform="translate(-0.247 -455.991)" fill="#3f3d56"/>
          <path id="Path_209" data-name="Path 209" d="M282.243,175.6l-2.019,1.076a47.892,47.892,0,0,0-9.111-12.9,44.305,44.305,0,0,0-64.738,1.339c-17.5,19.113-16.925,49.61,1.275,67.985a45.8,45.8,0,0,0,11.759,8.619l-.987,2.139c-18.833-9.6-29.577-30.906-26.561-52.662s19.1-38.957,39.759-42.521S272.757,156,282.243,175.6Z" transform="translate(-183.736 -148.004)" fill="#3f3d56"/>
          <path id="Path_210" data-name="Path 210" d="M274.148,434.567a17.57,17.57,0,0,0,.45,23.986,15.614,15.614,0,0,0,22.84-.472l2.781-3.038-23.29-23.513Z" transform="translate(-243.934 -362.745)" fill="#3f3d56"/>
          <path id="Path_211" data-name="Path 211" d="M291.1,420.8a3.922,3.922,0,0,0,.1,5.347l21.361,21.566a3.481,3.481,0,0,0,5.092-.105,3.917,3.917,0,0,0-.1-5.347l-21.361-21.566a3.485,3.485,0,0,0-5.092.105Z" transform="translate(-259.664 -353.74)" fill="#fff"/>
          <path id="Path_212" data-name="Path 212" d="M494.249,252.715l2.781-3.038a17.57,17.57,0,0,0-.45-23.986,15.614,15.614,0,0,0-22.84.472l-2.781,3.038Z" transform="translate(-398.745 -203.258)" fill="#3f3d56"/>
          <path id="Path_213" data-name="Path 213" d="M460.247,244.855a3.922,3.922,0,0,0,.1,5.347l21.361,21.566a3.481,3.481,0,0,0,5.092-.105,3.917,3.917,0,0,0-.1-5.347l-21.361-21.566A3.485,3.485,0,0,0,460.247,244.855Z" transform="translate(-389.736 -220.48)" fill="#fff"/>
          <path id="Path_214" data-name="Path 214" d="M502.593,442.469v-1.752s7.281-4.3,13.2,0v1.593Z" transform="translate(-423.071 -368.256)" fill="#535461"/>
          <path id="Path_215" data-name="Path 215" d="M789.529,442.469v-1.752s7.281-4.3,13.2,0v1.593Z" transform="translate(-643.72 -368.256)" fill="#535461"/>
          <path id="Path_216" data-name="Path 216" d="M473.431,446.761H466.3s-1.82-2.23-7.888-2.071-7.281,2.071-7.281,2.071-5.992,4.221-7.357,9.478c0,0-7.357,23.177-7.508,41.337s6.522,20.708,10.011,21.186,9.708-.159,15.775-16.248l2.579-9.4s.455-5.575,5.916-2.071,10.315-1.911,10.315-1.911h20.478s6.826,4.46,13.045.956c0,0,2.427-3.345,4.7,7.965,0,0,6.977,23.257,17.747,20.867s9.556-21.823,9.556-21.823-1.441-29.708-7.357-40.222c0,0-5.688-10.912-9.48-11.39,0,0-8.191-1.593-11.376-.159l-1.82,1.593Z" transform="translate(-372.066 -372.707)" fill="#3f3d56"/>
          <ellipse id="Ellipse_72" data-name="Ellipse 72" cx="13.197" cy="13.859" rx="13.197" ry="13.859" transform="translate(71.634 75.806)" fill="#535461"/>
          <ellipse id="Ellipse_73" data-name="Ellipse 73" cx="13.197" cy="13.859" rx="13.197" ry="13.859" transform="translate(140.5 75.806)" fill="#535461"/>
          <path id="Path_217" data-name="Path 217" d="M519.295,486.161l-1.76,1.634a.787.787,0,0,1-1.078,0l-1.763-1.634a.875.875,0,0,1-.276-.637v-4.5a.837.837,0,0,1,.816-.855h3.527a.836.836,0,0,1,.816.854v4.5A.874.874,0,0,1,519.295,486.161Z" transform="translate(-432.164 -399.586)" fill="#e6e6e6"/>
          <path id="Path_218" data-name="Path 218" d="M519.295,524.564l-1.76-1.633a.787.787,0,0,0-1.078,0l-1.763,1.634a.875.875,0,0,0-.276.637V529.7a.836.836,0,0,0,.813.857h3.53a.836.836,0,0,0,.816-.854V525.2A.874.874,0,0,0,519.295,524.564Z" transform="translate(-432.164 -431.811)" fill="#e6e6e6"/>
          <path id="Path_219" data-name="Path 219" d="M493.873,511.567l1.556-1.851a.89.89,0,0,0,0-1.133l-1.556-1.851a.8.8,0,0,0-.607-.29h-4.278a.837.837,0,0,0-.815.857V511a.836.836,0,0,0,.813.857h4.281A.8.8,0,0,0,493.873,511.567Z" transform="translate(-411.983 -419.484)" fill="#e6e6e6"/>
          <path id="Path_220" data-name="Path 220" d="M532.462,511.562l-1.553-1.853a.888.888,0,0,1,0-1.133l1.556-1.851a.8.8,0,0,1,.607-.29h4.278a.836.836,0,0,1,.816.854V511a.836.836,0,0,1-.813.857h-4.279A.8.8,0,0,1,532.462,511.562Z" transform="translate(-444.689 -419.479)" fill="#e6e6e6"/>
          <ellipse id="Ellipse_74" data-name="Ellipse 74" cx="9.556" cy="10.036" rx="9.556" ry="10.036" transform="translate(93.174 94.762)" fill="#535461"/>
          <ellipse id="Ellipse_75" data-name="Ellipse 75" cx="9.556" cy="10.036" rx="9.556" ry="10.036" transform="translate(126.241 94.762)" fill="#535461"/>
          <ellipse id="Ellipse_76" data-name="Ellipse 76" cx="6.371" cy="6.69" rx="6.371" ry="6.69" transform="translate(96.359 98.107)" fill="#e6e6e6"/>
          <path id="Path_221" data-name="Path 221" d="M588.411,570.172a4.625,4.625,0,1,1,4.4-4.62A4.513,4.513,0,0,1,588.411,570.172Zm0-8.921a4.306,4.306,0,1,0,4.1,4.3,4.2,4.2,0,0,0-4.1-4.3Z" transform="translate(-485.681 -460.755)" fill="#535461"/>
          <ellipse id="Ellipse_77" data-name="Ellipse 77" cx="6.371" cy="6.69" rx="6.371" ry="6.69" transform="translate(129.427 98.107)" fill="#e6e6e6"/>
          <path id="Path_222" data-name="Path 222" d="M731.55,570.172a4.625,4.625,0,1,1,4.4-4.62A4.513,4.513,0,0,1,731.55,570.172Zm0-8.921a4.306,4.306,0,1,0,4.1,4.3,4.2,4.2,0,0,0-4.1-4.3Z" transform="translate(-595.753 -460.755)" fill="#535461"/>
          <ellipse id="Ellipse_78" data-name="Ellipse 78" cx="2.73" cy="2.867" rx="2.73" ry="2.867" transform="translate(116.837 103.045)" fill="#535461"/>
          <ellipse id="Ellipse_79" data-name="Ellipse 79" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(114.798 95.716)" fill="#535461"/>
          <ellipse id="Ellipse_80" data-name="Ellipse 80" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(117.031 95.716)" fill="#535461"/>
          <ellipse id="Ellipse_81" data-name="Ellipse 81" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(116.734 98.687)" fill="#535461"/>
          <ellipse id="Ellipse_82" data-name="Ellipse 82" cx="0.607" cy="0.637" rx="0.607" ry="0.637" transform="translate(118.809 98.744)" fill="#535461"/>
          <ellipse id="Ellipse_83" data-name="Ellipse 83" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(120.902 98.687)" fill="#535461"/>
          <ellipse id="Ellipse_84" data-name="Ellipse 84" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(115.84 97.281)" fill="#535461"/>
          <ellipse id="Ellipse_85" data-name="Ellipse 85" cx="0.607" cy="0.637" rx="0.607" ry="0.637" transform="translate(117.747 97.311)" fill="#535461"/>
          <ellipse id="Ellipse_86" data-name="Ellipse 86" cx="0.607" cy="0.637" rx="0.607" ry="0.637" transform="translate(119.719 97.311)" fill="#535461"/>
          <ellipse id="Ellipse_87" data-name="Ellipse 87" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(121.795 97.281)" fill="#535461"/>
          <ellipse id="Ellipse_88" data-name="Ellipse 88" cx="0.607" cy="0.637" rx="0.607" ry="0.637" transform="translate(118.809 95.718)" fill="#535461"/>
          <ellipse id="Ellipse_89" data-name="Ellipse 89" cx="0.607" cy="0.637" rx="0.607" ry="0.637" transform="translate(120.932 95.718)" fill="#535461"/>
          <ellipse id="Ellipse_90" data-name="Ellipse 90" cx="0.596" cy="0.626" rx="0.596" ry="0.626" transform="translate(122.689 95.716)" fill="#535461"/>
          <path id="Path_223" data-name="Path 223" d="M574.251,458.847a1.087,1.087,0,0,0-1.058,1.111V463.3a1.087,1.087,0,0,0,1.058,1.111h.758a1.087,1.087,0,0,0,1.058-1.111v-3.345a1.087,1.087,0,0,0-1.058-1.111Z" transform="translate(-477.361 -383.435)" fill="#535461"/>
          <path id="Path_224" data-name="Path 224" d="M765.979,458.847a1.087,1.087,0,0,0-1.058,1.111V463.3a1.087,1.087,0,0,0,1.058,1.111h.759A1.087,1.087,0,0,0,767.8,463.3v-3.345a1.087,1.087,0,0,0-1.058-1.111Z" transform="translate(-624.797 -383.436)" fill="#535461"/>
          <ellipse id="Ellipse_91" data-name="Ellipse 91" cx="3.64" cy="3.823" rx="3.64" ry="3.823" transform="translate(150.208 77.399)" fill="#e6e6e6"/>
          <ellipse id="Ellipse_92" data-name="Ellipse 92" cx="3.64" cy="3.823" rx="3.64" ry="3.823" transform="translate(142.472 85.523)" fill="#e6e6e6"/>
          <ellipse id="Ellipse_93" data-name="Ellipse 93" cx="3.64" cy="3.823" rx="3.64" ry="3.823" transform="translate(158.247 85.045)" fill="#e6e6e6"/>
          <ellipse id="Ellipse_94" data-name="Ellipse 94" cx="3.64" cy="3.823" rx="3.64" ry="3.823" transform="translate(150.814 93.488)" fill="#e6e6e6"/>
          <path id="Path_225" data-name="Path 225" d="M597.272,449.654a3.152,3.152,0,0,0-3.068,3.222v14.257a3.152,3.152,0,0,0,3.068,3.222h31.171a3.152,3.152,0,0,0,3.068-3.222V452.876a3.152,3.152,0,0,0-3.068-3.222Z" transform="translate(-493.518 -376.473)" fill="#535461"/>
          <path id="Path_226" data-name="Path 226" d="M818.6,476.625h-4.937l2.383-4.29Zm-4.409-.319h3.861l-2-3.356Z" transform="translate(-662.28 -393.651)" fill="#535461"/>
          <path id="Path_227" data-name="Path 227" d="M786.073,512.228h-4.1V508.4h4.1Zm-3.792-.319h3.489v-3.186h-3.489Z" transform="translate(-637.914 -420.971)" fill="#535461"/>
          <path id="Path_228" data-name="Path 228" d="M851.555,509.245a2.392,2.392,0,1,1,2.275-2.389A2.334,2.334,0,0,1,851.555,509.245Zm0-4.46a2.073,2.073,0,1,0,1.972,2.071,2.023,2.023,0,0,0-1.972-2.071Z" transform="translate(-689.668 -417.987)" fill="#535461"/>
          <path id="Path_243" data-name="Path 243" d="M.168.012.479,0,.358,4.952.047,4.96Z" transform="translate(152.477 95.741) rotate(-45)" fill="#535461"/>
          <path id="Path_244" data-name="Path 244" d="M.012.168,4.956.047,4.948.359,0,.48Z" transform="translate(152.481 98.796) rotate(-43.734)" fill="#535461"/>
          <path id="Path_229" data-name="Path 229" d="M229.361,258.692c-8.282,2.4-17.351,4.2-20.6,1.4a19.777,19.777,0,0,0,2.892-9.187,5.365,5.365,0,0,1,6.176-5.266l2.149.317q.109.016.216.036a5.174,5.174,0,0,1,4.042,4.448A11.467,11.467,0,0,0,229.361,258.692Z" transform="translate(-197.118 -221.91)" fill="#2f2e41"/>
          <path id="Path_230" data-name="Path 230" d="M294.909,361.074l3.22.7a1.7,1.7,0,0,1,1.158.919,1.856,1.856,0,0,1,.053,1.523h0a1.724,1.724,0,0,1-1.043.99,1.621,1.621,0,0,1-1.4-.181l-4.925-3.181-8.365-20.652,4.333-1.316Z" transform="translate(-254.677 -293.326)" fill="#a0616a"/>
          <path id="Path_231" data-name="Path 231" d="M60.611,377.684l-2.438.745-1.845-4L58.2,373.4Z" transform="translate(-43.316 -282.836)" fill="#a0616a"/>
          <path id="Path_232" data-name="Path 232" d="M59.55,442.3l-2.991-.832.468-5.4,2.574.166Z" transform="translate(-43.493 -330.303)" fill="#a0616a"/>
          <path id="Path_233" data-name="Path 233" d="M175.849,441.911,172.68,444.1,160.5,429.627a2.951,2.951,0,0,1-.649-2.327,2.86,2.86,0,0,1,1.291-2.01l15.179-9.525,2.325,7.014-7.9,7.789Z" transform="translate(-159.48 -350.805)" fill="#2f2e41"/>
          <path id="Path_234" data-name="Path 234" d="M221.132,534.65l-.024.032a5.8,5.8,0,0,1-1.352,3.2,2.328,2.328,0,0,1-2.87,1.361h0a2.486,2.486,0,0,1-1.639-2.643l.592-5.557a4.02,4.02,0,0,0,3.051-2.841l1.38.987a3.832,3.832,0,0,1,1.548,2.534A3.955,3.955,0,0,1,221.132,534.65Z" transform="translate(-202.095 -435.968)" fill="#2f2e41"/>
          <ellipse id="Ellipse_95" data-name="Ellipse 95" cx="4.876" cy="5.121" rx="4.876" ry="5.121" transform="translate(15.663 25.35)" fill="#a0616a"/>
          <path id="Path_235" data-name="Path 235" d="M237.969,291.391l-7.687,6.686-.6-2.752,1.342-2.148a16.36,16.36,0,0,0-.508-6.9l5.015,0A7.845,7.845,0,0,0,237.969,291.391Z" transform="translate(-213.208 -252.734)" fill="#a0616a"/>
          <path id="Path_236" data-name="Path 236" d="M230.5,322.745l-10.378,3.32-.807-3.876c-1.945-2.742-2.79-5.245-1.518-7.287l-.64-3.074a15.214,15.214,0,0,0,4.074-4.685l6.385-2.62,4.694.3L233.7,309.7Z" transform="translate(-203.577 -266.55)" fill="#6c63ff"/>
          <path id="Path_237" data-name="Path 237" d="M286.207,314.591a10.336,10.336,0,0,0-6.2,1.994l.634-10.813h0a3.767,3.767,0,0,1,2.944,2.354Z" transform="translate(-251.909 -267.497)" fill="#6c63ff"/>
          <path id="Path_238" data-name="Path 238" d="M218.117,428.214l-3.294-.851.485-29.392,4.423-5.087-.99-6.448-.641-7.224,10.8-2.813c3.652,6.963,5.859,13.294,2.637,17.249Z" transform="translate(-201.78 -320.989)" fill="#2f2e41"/>
          <path id="Path_239" data-name="Path 239" d="M199.488,605.261l-.044.018a6.586,6.586,0,0,1-3.329,2.452,2.783,2.783,0,0,1-3.811-.473h0a3.142,3.142,0,0,1-.129-3.841l3.944-5.411a4.639,4.639,0,0,0,4.886-.952l.85,1.942a4.857,4.857,0,0,1,.1,3.668A4.539,4.539,0,0,1,199.488,605.261Z" transform="translate(-183.908 -488.112)" fill="#2f2e41"/>
          <path id="Path_240" data-name="Path 240" d="M161.913,385.155l-2.891,2.6a2.024,2.024,0,0,0-.637,1.776,1.962,1.962,0,0,0,1.085,1.517h0a1.834,1.834,0,0,0,2.425-.865l2.091-4.1,9.588-18.375L169.968,367Z" transform="translate(-158.365 -313.871)" fill="#a0616a"/>
          <path id="Path_241" data-name="Path 241" d="M210.1,343.712c-1.873-.594-3.627-.943-4.987-.482.285-3.706.873-7.017,2.784-8.6l2.716.335Z" transform="translate(-194.311 -289.355)" fill="#6c63ff"/>
          <path id="Path_242" data-name="Path 242" d="M236.119,254.213l-10.429-.674.128-2.19q5.461-3.867,10.429.674Z" transform="translate(-210.137 -224.93)" fill="#2f2e41"/>
        </g>
      </g>
    </g>
  </g>
</svg> */
}
